import { render } from "./UpcomingEventsSlider.vue?vue&type=template&id=5f470417"
import script from "./UpcomingEventsSlider.vue?vue&type=script&lang=js"
export * from "./UpcomingEventsSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__